'use client'
import { useLanguage } from '@/lib/context/LanguageContext'
import FadeInUp from '@/components/ui/FadeInUp'

/**
 * Mid-page conversion band. Sits between the navy MarketReach map and the
 * cream FAQ to break the long Why → Markets → FAQ stretch that previously
 * carried no call to action (skill: CTA cadence). Deliberately lighter than
 * the maroon closing ContactCTA — a single crimson button on a warm cream
 * band — so it nudges without pre-empting the finale. Both lead to #contact.
 */
export default function MidCTA() {
  const { t, isRTL } = useLanguage()
  const arrow = isRTL ? '←' : '→'

  return (
    <section
      className="relative bg-surface-alt py-20 sm:py-28"
      style={{ direction: isRTL ? 'rtl' : 'ltr' }}
    >
      <FadeInUp className="mx-auto flex max-w-2xl flex-col items-center px-5 text-center sm:px-8">
        <span aria-hidden className="mb-6 block h-px w-10 bg-accent" />
        <p className="text-[11px] uppercase tracking-[0.22em] font-medium text-accent">
          {t.midCta.eyebrow}
        </p>
        <h2
          className="mt-5 font-display-serif text-3xl leading-[1.12] text-ink sm:text-4xl"
          style={{ fontVariationSettings: '"opsz" 48, "wght" 600' }}
        >
          {t.midCta.heading}
        </h2>
        <p className="mt-4 max-w-xl text-base leading-relaxed text-ink-muted">
          {t.midCta.sub}
        </p>
        <a
          href="#contact"
          className="focus-ring mt-9 inline-flex items-center justify-center gap-2 bg-action px-7 py-3.5 text-sm font-semibold text-surface shadow-[0_10px_28px_-12px_rgba(123,9,7,0.5)] transition duration-200 hover:bg-accent active:scale-[0.98]"
        >
          {t.midCta.button}
          <span aria-hidden>{arrow}</span>
        </a>
      </FadeInUp>
    </section>
  )
}
